import { AxiosInstance } from 'axios';
import { FacilityRepository } from '@/model/repository/manager/facility/FacilityRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): FacilityRepository => ({
    get() {
      return Repository.get(`${resource}`);
    },
    isBetaFacility(featureName: string) {
      return Repository.get(`${resource}/beta-features/${featureName}`);
    },
  });
